import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  props: {
    balance: {
      type: String,
    },
    restricted: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_RESTRICTED_FUNDS_INFO);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/available-balance/available-balance.js